
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/guidebook/summary/facility",
      function () {
        return require("private-next-pages/guidebook/summary/facility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/guidebook/summary/facility"])
      });
    }
  